<template>
  <span class="center" @click="onClickButton">{{displayText}}</span>
</template>

<script>
export default {
  props: {
    targetTable: Object,
  },
  computed: {
    displayText() {
      return this.targetTable && this.targetTable.isAllChecked ? '선택해제' : '전체선택'
    }
  },
  methods: {
    onClickButton() {
      this.targetTable.toggleChecked()
    }
  }
}
</script>